import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Barcode from 'react-barcode';

import useComponentBounds from '../../../../hooks/useComponentBounds';

const propTypes = {
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.shape({
      code: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

const CardElementBarCode = ({ element }) => {
  const { cardElementConfiguration } = element;
  const { code } = cardElementConfiguration;
  const ref = useRef();
  const { bounds } = useComponentBounds(ref);

  const containerWidth = bounds?.width || 0;
  const containerHeight = bounds?.height || 0;

  // Calculate barcode bar width based on available container width
  // A typical barcode for a string like 'VIVA LA VIDA' in CODE128 is ~130 modules wide
  // We estimate and let JsBarcode scale accordingly
  const barcodeWidth =
    containerWidth > 0 ? Math.max(1, containerWidth / 130) : 1;

  return (
    <div ref={ref} className="card-element card-element-bar-code">
      {!!code && !!containerWidth && !!containerHeight && (
        <Barcode
          value={code}
          width={barcodeWidth}
          fontSize={16}
          height={Math.max(containerHeight - 20, 0)}
          displayValue
          margin={0}
        />
      )}
    </div>
  );
};

CardElementBarCode.propTypes = propTypes;

export default CardElementBarCode;
